// extracted by mini-css-extract-plugin
export default {"myModal":"MyModal_myModal__6+pWN","myModalContent":"MyModal_myModalContent__6J+MJ","active":"MyModal_active__2Oh7U"};